// extracted by mini-css-extract-plugin
module.exports = {"title":"YoutubeAnalytics_title__1GgME","itemContainer":"YoutubeAnalytics_itemContainer__XDMm_","label":"YoutubeAnalytics_label__2dTOj","value":"YoutubeAnalytics_value__UkEPH"};